"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";

export function ThemeWrapper({
  children,
  redirectParam = "",
}: {
  children: React.ReactNode;
  /** 認証画面の ?redirect=（(auth)/layout.tsx から渡す） */
  redirectParam?: string;
}) {
  const pathname = usePathname();

  const isJkkPath = pathname.startsWith("/jkk");
  const isJkkRedirect = redirectParam.startsWith("/jkk");

  const [storedProvider, setStoredProvider] = useState<string | null>(null);
  useEffect(() => {
    setStoredProvider(localStorage.getItem("provider"));
  }, []);

  useEffect(() => {
    if (pathname.startsWith("/jkk")) {
      localStorage.setItem("provider", "jkk");
    } else if (pathname.startsWith("/ur")) {
      localStorage.setItem("provider", "ur");
    }
  }, [pathname]);

  const isJkk = isJkkPath || isJkkRedirect || (!isJkkPath && !pathname.startsWith("/ur") && storedProvider === "jkk");
  const theme = isJkk ? "jkk" : "ur";

  return <div data-theme={theme}>{children}</div>;
}
